import { DOCUMENT } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { IQueryParam } from '@interfaces/fast-report-params';

import { UstawieniaUzytkownikaService } from './api/administracja/systems/ustawienia-uzytkownika.service';

export const printKeys = {
  programStudiow: {
    programStudiow: 'ogolnyOpisProgramuStudiow',
    macierzPokryciaEfektow: 'macierzPokryciaEfektow',
    obsadaZajec: 'obsadaZajec',
    planProgramuStudiow: 'planProgramuStudiow',
  },
  finanseNotaOdsetkowa: 'finanseNotaOdsetkowa',
  finanse: {
    zestawienieRozrachunkowZeStudentami: 'zestawienieRozrachunkowZeStudentami',
    zestawienieNaliczen: 'zestawienieNaliczen',
    eksportWplatDoSystemuKsiegowego: 'eksportWplatDoSystemuKsiegowego',
    eksportOplatDoSystemuKsiegowego: 'eksportOplatDoSystemuKsiegowego',
    zestawienieWplat: 'zestawienieWplat',
    oplatyIZaleglosci: 'oplatyIZaleglosciNaKierunku',
    oplatyZaCzesneZPodzialemNaBonifikaty: 'oplatyZaCzesneZPodzialemNaBonifikaty',
    zaleglosciStudentow: 'zaleglosciStudentow',
    listaStudentowZLiczbaNalionychOplat: 'listaStudentowZLiczbaNalionychOplat',
    zestawienieWplatZPodzialemNaZaleglePrzyszleBiezace: 'zestawienieWplatZPodzialemNaZaleglePrzyszleBiezace',
    raportKasowy: 'raportKasowy',
    raportKontrolnyWplatZImportu: 'raportKontrolnyWplatZImportu',
    wykazObciazenZbiorczy: 'wykazObciazenZbiorczy',
    faktura: 'faktura',
    wykazObciazenZPodzialemNaRokStudiow: 'wykazObciazenZPodzialemNaRokStudiow',
  },
  kartaOkresowychOsiagniecStudenta: 'kartaOkresowychOsiagniecStudenta',
  studenci: {
    ankietyOsobowe: 'ankietyOsobowe',
    zestawienieNaliczenIWplatStudenta: 'zestawienieNaliczenIWplatStudenta',
    kartyOkresowychOsiagniecStudentow: 'kartyOkresowychOsiagniecStudentow',
    programyStudiowStudentow: 'programyStudiowStudentow',
    kartyPrzebieguStudiowStudentow: 'kartyPrzebieguStudiowStudentow',
    zaswiadczenieStudenta: 'zaswiadczenieStudenta',
    naklejkaNaTeczkeMasowa: 'naklejkaNaTeczkeMasowa',
    wezwanieDoZaplaty: 'wezwanieDoZaplaty',
    wezwanieDoZaplatyOstateczne: 'wezwanieDoZaplatyOstateczne',
    decyzjaOSkresleniu: 'decyzjaOSkresleniu',
    decyzjaOUrlopie: 'decyzjaOUrlopie',
    kartyObiegowe: 'kartyObiegowe ',
    daneKontaktoweStudentow: 'daneKontaktoweStudentow',
    sredniaOcenZaWybraneSemestryStudenta: 'sredniaOcenZaWybraneSemestryStudenta',
    elektroniczneSlubowania: 'elektroniczneSlubowania',
    zaswiadczeniaOKredytNaStudiaMedyczne: 'zaswiadczeniaOKredytNaStudiaMedyczne',
  },
  studenciGrupyZajec: 'studenciGrupyZajec',
  studenciGrupZajec: 'studenciGrupZajec',
  studenciGrupyDziekanskiej: 'studenciGrupyDziekanskiej',
  studia: {
    protokolyOcen: 'protokolyOcen',
    rejestrZaswiadczen: 'rejestrZaswiadczen',
    planStudiowNaboruProgramuStudiow: 'planStudiowNaboruProgramuStudiow',
    planZajec: 'planZajec',
    planZajecStudenta: 'planZajecStudenta',
    planZajecPracownikaNaukowego: 'planZajecPracownikaNaukowego',
    planZajecPlatformaStudenta: 'planZajecPlatformaStudenta',
  },
  praktyki: {
    studenciNaOferciePraktyk: 'studenciNaOferciePraktyk',
  },
  salaKodQR: 'salaKodQR',
};

const endpoint = `${environment.fastReportUrl}/raporty/`;

@Injectable({
  providedIn: 'root',
})
export class FastReportService {
  private jezykId: string;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly ustawieniaUzytkownikaService: UstawieniaUzytkownikaService,
  ) {
    this.ustawieniaUzytkownikaService.ustawieniaUzytkownika.subscribe((res) => {
      this.jezykId = res.jezykId;
    });
  }

  get window(): Window {
    return this.document.defaultView;
  }

  createQueryParams(params: Record<string, any>): IQueryParam[] {
    const query = [];
    for (const key in params) {
      if (key) {
        query.push({
          parameter: `${key}`,
          value: this.parseParamsValue(params[key]),
        });
      }
    }
    return query;
  }

  parseParamsValue(value: any): any {
    if (!value && value !== 0 && !(typeof value === 'boolean')) {
      return '';
    } else if (value instanceof Array) {
      return value.join(';');
    }
    return value;
  }

  navigate(key: string, queryParams: IQueryParam[] = []): Promise<boolean> {
    const url = `${endpoint + key}?${this.composeQuery(queryParams)}`;
    return new Promise<boolean>((resolve, reject) => {
      try {
        resolve(!!this.window.open(url, '_blank', 'noopener'));
      } catch (e) {
        reject(e);
      }
    });
  }

  private composeQuery(queryParams: IQueryParam[]): HttpParams {
    let params = new HttpParams();
    queryParams.forEach((item) => {
      params = params.append(item.parameter, item.value ?? '');
    });
    if (!params.has('jezykId')) {
      params = params.append('jezykId', this.jezykId);
    }
    return params;
  }
}
